import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { getOrganizationMainRoles } from "@/components/Roles";
import { useUpdateUser } from "@/entities/user";

import UserForm from "../UserForm";

const UserEdit = ({ model }) => {
  const { t } = useTranslation();

  const mutation = useUpdateUser(model.id);

  // get the user main roles on his organization
  const mainRoles = getOrganizationMainRoles({
    roles: model.roles,
    organizationId: model.organization_id,
  });

  const saveButtonLabel = t("global:update");
  const initialValues = {
    name: model.name,
    email: model.email,
    organization: {
      label: model.organization?.name,
      value: model.organization_id,
      key: model.organization_id,
    },
    role: mainRoles?.[0]?.behavior,
  };

  return (
    <UserForm
      model={model}
      mutation={mutation}
      saveButtonLabel={saveButtonLabel}
      initialValues={initialValues}
    />
  );
};

UserEdit.propTypes = {
  model: PropTypes.object.isRequired,
};

export default UserEdit;
